/**
 * The CRM lead stages, in the order the pipeline runs.
 *
 * One list, because there were three and they disagreed. The email campaign
 * composer offered eleven stages, CustomersList offered thirteen, and the
 * WhatsApp campaign composer offered none at all — it took free text with a
 * placeholder suggesting "Interested", which is not a stage in this product.
 * Audience filtering matches the stage exactly, so a value that is not on this
 * list silently resolves to an audience of nobody.
 *
 * Must track CustomerDetails.LEAD_STAGE in trustedge/customers/models.py.
 */

export const LEAD_STAGES = [
    "New Lead",
    "Contacted",
    "Qualified",
    "Demo Fixed",
    "Demo Done",
    "No Show",
    "Proposal",
    "Negotiation",
    "Closed Won",
    "Closed Lost",
    "On Hold",
    "Unanswered",
    "Dis-Qualified",
    "Nurture Lead",
    "Onboarded",
];

/** Channel-partner accounts run a different lifecycle — CP_LEAD_STAGE server-side. */
export const CP_LEAD_STAGES = [
    "Onboarding",
    "Agreement Signed",
    "Active",
    "Inactive",
    "Suspended",
    "Terminated",
];
